import React from 'react';


export const documentFormatter = (t) => (cell, row) => {
    let letter = ''
    let badgeColor = ''

    switch (row.status) {
        case 'billing':
            letter = 'F'
            badgeColor = '#5B21B6' // Violet profond
            break;

        case 'billingBuy':
            letter = 'FA'
            badgeColor = '#166534' // Vert forêt dense
            break;

        case 'billingDeposit':
            letter = 'AC'
            badgeColor = '#1D4ED8' // Bleu royal
            break;

        case 'returnNote':
            letter = 'BR'
            badgeColor = '#991B1B' // Rouge sombre
            break;

        case 'quotation':
            letter = 'D'
            badgeColor = '#0C4A6E' // Bleu marine
            break;

        case 'purchaseOrderB2b':
            letter = 'BC'
            badgeColor = '#92400E' // Ambre foncé
            break;

        case 'deliveryNote':
            letter = 'BL'
            badgeColor = '#78350F' // Brun chaud
            break;

        case 'creditNote':
            letter = 'A'
            badgeColor = '#9D174D' // Framboise foncé
            break;

        case 'creditNoteBuy':
            letter = 'AVF'
            badgeColor = '#9D3A6B' // Rose-framboise fournisseur
            break;

        default:
            break;
    }


    return <><span className="badge" style={{backgroundColor:badgeColor}}>{letter}</span>&nbsp;&nbsp;{cell}</>;
};

export const withLogoHeader = (doc,str) => {
    let letter = ''
    let badgeColor = ''

    switch (doc) {
        case 'billing':
            letter = 'F'
            badgeColor = '#5B21B6' // Violet profond
            break;

        case 'billingBuy':
            letter = 'FA'
            badgeColor = '#166534' // Vert forêt dense
            break;

        case 'billingDeposit':
            letter = 'AC'
            badgeColor = '#1D4ED8' // Bleu royal
            break;

        case 'returnNote':
            letter = 'BR'
            badgeColor = '#991B1B' // Rouge sombre
            break;

        case 'quotation':
            letter = 'D'
            badgeColor = '#0C4A6E' // Bleu marine
            break;

        case 'purchaseOrderB2b':
            letter = 'BC'
            badgeColor = '#92400E' // Ambre foncé
            break;

        case 'deliveryNote':
            letter = 'BL'
            badgeColor = '#78350F' // Brun chaud
            break;

        case 'creditNote':
            letter = 'A'
            badgeColor = '#9D174D' // Framboise foncé
            break;

        case 'creditNoteBuy':
            letter = 'AVF'
            badgeColor = '#9D3A6B' // Rose-framboise fournisseur
            break;

        default:
            break;
    }


    return <div className="d-flex align-items-center gap-2">
        <span
            className="badge"
            style={{ backgroundColor: badgeColor }}
        >
            {letter}
        </span>
        <span>{str}</span>
    </div>;
};

export const cellStyleEtat = (t) => (cell, row) => {
    // cell = valeur de row.etat
    const style = {};

    if (row.cancelled) {
        style.backgroundColor = '#fccfcf';
        return style;
    }

    if (row.status === 'billing' || row.status === 'billingBuy') {
        if (row.etat === t('acquitte')) style.backgroundColor = '#d9fcd2';
        if (row.etat === t('partiallyAcquitte')) style.backgroundColor = '#ffffbb';
        if (row.etat === t('notAcquitte')) style.backgroundColor = '#e9e7e5';
    }

    if (row.status == 'purchaseOrderB2b') {
        if (row.etat === t('collected')) style.backgroundColor = '#d9fcd2';
        if (row.etat === t('collectInProgress')) style.backgroundColor = '#ffffbb';
        if (row.etat === t('notCollected')) style.backgroundColor = '#e9e7e5';
    }

    if (row.status == 'deliveryNote') {
        if (row.etat === t('delivered2')) style.backgroundColor = '#d9fcd2';
        if (row.etat === t('notDelivered2')) style.backgroundColor = '#e9e7e5';
    }

    if (row.status == 'creditNote' || row.status == 'creditNoteBuy') {
        if (row.etat === t('used')) style.backgroundColor = '#d9fcd2';
        if (row.etat === t('partiallyUsed')) style.backgroundColor = '#ffffbb';
        if (row.etat === t('unUsed')) style.backgroundColor = '#e9e7e5';
    }

    if (row.status == 'quotation') {
        if (row.etat_conversion != t('converted')) {
            if (row.etat === t('expired')) style.backgroundColor = '#ffffbb';
            if (row.etat === t('notExpired')) style.backgroundColor = '#e9e7e5';
        }
    }

    if (row.status == 'returnNote') {
        if (row.etat === t('collected')) style.backgroundColor = '#d9fcd2';
        if (row.etat === t('collectInProgress')) style.backgroundColor = '#ffffbb';
        if (row.etat === t('notCollected')) style.backgroundColor = '#e9e7e5';
    }

    if (row.status == 'billingDeposit') {
        if (row.etat === t('used')) style.backgroundColor = '#d9fcd2';
        if (row.etat === t('partiallyUsed')) style.backgroundColor = '#ffffbb';
        if (row.etat === t('unUsed')) style.backgroundColor = '#e9e7e5';
    }

    return style;
};

export const cellStyleEtatConversion = (t) => (cell, row) => {
    // cell = valeur de row.etat_conversion
    const style = {};

    if (row.cancelled) {
        style.backgroundColor = '#fccfcf';
        return style;
    }

    if (row.status == 'purchaseOrderB2b' || row.status == 'creditNote' || row.status == 'creditNoteBuy') {
        if (row.etat_conversion === t('converted')) style.backgroundColor = '#d9fcd2';
        if (row.etat_conversion === t('partiallyConverted')) style.backgroundColor = '#ffffbb';
        if (row.etat_conversion === t('notConverted')) style.backgroundColor = '#e9e7e5';
    }

    if (row.status == 'deliveryNote') {
        if (row.etat_conversion === t('isFactured')) style.backgroundColor = '#d9fcd2';
        if (row.etat_conversion === t('isNotFactured')) style.backgroundColor = '#e9e7e5';
    }

    if (row.status == 'quotation') {
        if (row.etat_conversion === t('converted')) style.backgroundColor = '#d9fcd2';
        if (row.etat_conversion === t('notConverted')) style.backgroundColor = '#e9e7e5';
    }

    return style;
};

export const rowStyle = (t) => (row) => {
    const style = {};

    if(row.cancelled) {
        style.backgroundColor = '#fccfcf';//annulé
    }
    else{
        switch (row.status) {
            case 'billing':
            case 'billingBuy':
                if (row.etat==t('acquitte')) style.backgroundColor = '#d9fcd2';//finalisé
                break;
            case 'billingDeposit':
                if (row.etat==t('used')) style.backgroundColor = '#d9fcd2';//finalisé
                break;
            case 'returnNote':
                if (row.etat==t('collected')) style.backgroundColor = '#d9fcd2';//finalisé
                break;
            case 'quotation':
                if (row.etat_conversion==t('converted')) style.backgroundColor = '#d9fcd2';//finalisé
                break;
            case 'purchaseOrderB2b':
                if (row.etat === t('collected') && row.etat_conversion === t('converted')) style.backgroundColor = '#d9fcd2';
                break;
            case 'deliveryNote':
                if (row.etat === t('delivered2') && row.etat_conversion === t('isFactured')) style.backgroundColor = '#d9fcd2';
                break;
            case 'creditNote':
            case 'creditNoteBuy':
                if (row.etat === t('used') && row.etat_conversion === t('converted')) style.backgroundColor = '#d9fcd2';
                break;
            default:
                break;
        }
    }
    
    return style;
};
